import { PATIENT } from "../constants";

const initialState = {
  limit: 20,
  offset: 0,
  total: 0,
  query: "",
  noSubscription: false,
  moduleFilter: null,
  patients: [],
  patient: null,
  isLoadingGetPatient: true,
  isLoadingGetPatients: true,
  isLoadingCreatePatient: true,
  isLoadingUpdatePatient: true,
  isLoadingDeletePatient: true,
  error: null,
};

const patientsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case PATIENT.GET_PATIENTS:
      return {
        ...state,
        isLoadingGetPatients: true,
      };
    case PATIENT.GET_PATIENTS_FAILURE:
      return {
        ...state,
        isLoadingGetPatients: false,
        error: action.payload,
      };
    case PATIENT.GET_PATIENTS_SUCCESS:
      return {
        ...state,
        isLoadingGetPatients: false,
        patients: action.payload.data,
        total: action.payload.total,
        error: null,
      };
    case PATIENT.CREATE_PATIENT:
      return {
        ...state,
        isLoadingCreatePatient: true,
      };
    case PATIENT.CREATE_PATIENT_FAILURE:
      return {
        ...state,
        isLoadingCreatePatient: false,
        error: action.payload,
      };
    case PATIENT.CREATE_PATIENT_SUCCESS:
      return {
        ...state,
        isLoadingCreatePatient: false,
        patient: action.payload,
        error: null,
      };
    case PATIENT.GET_PATIENT:
      return {
        ...state,
        isLoadingGetPatient: true,
      };
    case PATIENT.GET_PATIENT_FAILURE:
      return {
        ...state,
        isLoadingGetPatient: false,
        error: action.payload,
      };
    case PATIENT.GET_PATIENT_SUCCESS:
      return {
        ...state,
        isLoadingGetPatient: false,
        patient: action.payload,
        error: null,
      };
    case PATIENT.UPDATE_PATIENT:
      return {
        ...state,
        isLoadingUpdatePatient: true,
      };
    case PATIENT.UPDATE_PATIENT_FAILURE:
      return {
        ...state,
        isLoadingUpdatePatient: false,
        error: action.payload,
      };
    case PATIENT.UPDATE_PATIENT_SUCCESS:
      return {
        ...state,
        isLoadingUpdatePatient: false,
        patient: action.payload,
        error: null,
      };
    case PATIENT.DELETE_PATIENT:
      return {
        ...state,
        isLoadingDeletePatient: true,
      };
    case PATIENT.DELETE_PATIENT_FAILURE:
      return {
        ...state,
        isLoadingDeletePatient: false,
        error: action.payload,
      };
    case PATIENT.DELETE_PATIENT_SUCCESS:
      return {
        ...state,
        isLoadingDeletePatient: false,
        error: null,
      };
    case PATIENT.SET_OFFSET:
      return {
        ...state,
        offset: action.payload,
      };
    case PATIENT.SET_QUERY:
      return {
        ...state,
        query: action.payload,
        offset: 0,
      };
    case PATIENT.SET_NO_SUBSCRIPTION:
      return {
        ...state,
        noSubscription: action.payload,
        offset: 0,
      };
    case PATIENT.SET_MODULE_FILTER:
      return {
        ...state,
        moduleFilter: action.payload,
        offset: 0,
      };
    case PATIENT.CLEAN_ERROR:
      return {
        ...state,
        error: null,
      };
    case PATIENT.CLEAN_PATIENT:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default patientsReducer;
